import React from 'react';
import { WebCamera } from '../components';
import { AttachmentCamera, AttachmentDoc, AttachmentImageVideo, AttachMusic } from '../rootAccess';
import logger from '../../Helpers/logger';
import { resetActionModal, setActionModal } from './actionModalUtils';
import { handleSendMediaMessage } from './conversationActions';

const handleCapture = (file, message) => {
    try {
        resetActionModal();

        // Attach custom properties directly to the File object
        file.fileDetails = {
            ...(file.fileDetails || {}),
            msgType: 'image',
        };
        file.caption = message?.trim();
        file.mentionedUsersIds = [];

        handleSendMediaMessage([file]);
    } catch (error) {
        logger.error('Failed to capture:', error);
    }
};
export const attachmentItems = [
    {
        icon: <AttachmentCamera />,
        label: 'Camera',
        onFileChange: () => {
            setActionModal({
                visible: true,
                body: <WebCamera onCapture={handleCapture} onClose={resetActionModal} attachment />,
                onRequestClose: () => resetActionModal(),
            });
        },
    },
    {
        icon: <AttachmentDoc />,
        label: 'Document',
        accept: '.pdf,.doc,.docx,.xls,.xlsx,.txt',
        mediaType: 'file',
    },
    {
        icon: <AttachmentImageVideo />,
        label: 'Photo / Video',
        accept: '.mp4,.x-m4v,.png,.jpeg,.jpg,video/x-m4v,.mov',
        mediaType: 'imagevideo',
    },
    {
        icon: <AttachMusic />,
        label: 'Audio',
        accept: '.wav,.mp3,.aac',
        mediaType: 'audio',
    },
];
